/* Vendor-promo countdown (calls spec 2026-09-29 §4, design C).
   One file, two hosts: a plain browser script (deferred from snippets/promo-countdown.liquid,
   attaches window.OrganaPromo and boots itself) and a CommonJS module (tests/promo-countdown.test.js).
   Not part of empire.min.js. Markup contract: [data-promo-countdown][data-end="YYYY-MM-DD"] with
   <b data-u="d|h|m"> numbers and <span data-l="d|h|m" data-one data-other> labels. */
(function (root) {
  // UTC offset (minutes) of `tz` at the instant `atMs`, e.g. Europe/Athens winter = 120.
  function offsetMin(tz, atMs) {
    const s = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'longOffset' })
      .formatToParts(new Date(atMs)).find(p => p.type === 'timeZoneName').value; // "GMT+02:00"
    const m = s.match(/GMT([+-])(\d{2}):(\d{2})/);
    return m ? (m[1] === '-' ? -1 : 1) * (+m[2] * 60 + +m[3]) : 0;
  }
  // Epoch ms of 23:59:59.999 wall-clock time in `tz` on the date `ymd` (DST-correct).
  // The offset is sampled 3 h before the wall time, so a DST switch (04:00 local, last
  // Sunday of March/October) can't bleed into the 23:59 answer.
  function promoEndInstant(ymd, tz) {
    tz = tz || 'Europe/Athens';
    const [y, mo, d] = ymd.split('-').map(Number);
    const wall = Date.UTC(y, mo - 1, d, 23, 59, 59, 999);
    return wall - offsetMin(tz, wall - 3 * 36e5) * 6e4;
  }
  function promoRemaining(now, end) {
    const ms = end - now;
    if (ms <= 0) return { d: 0, h: 0, m: 0, done: true };
    return { d: Math.floor(ms / 864e5), h: Math.floor(ms % 864e5 / 36e5),
             m: Math.floor(ms % 36e5 / 6e4), done: false };
  }
  // «1 ημέρα» but «0 / 2 / 11 ημέρες»: singular only for exactly 1.
  function promoUnitLabel(n, one, other) {
    return n === 1 ? one : other;
  }
  function boot() {
    document.querySelectorAll('[data-promo-countdown]').forEach(box => {
      let end;
      try { end = promoEndInstant(box.dataset.end); } catch (e) { end = NaN; }
      if (!isFinite(end)) return; // no usable end date: the units stay hidden, the text stays
      let timer = 0;
      const put = (u, n, text) => {
        box.querySelector('[data-u=' + u + ']').textContent = text;
        const l = box.querySelector('[data-l=' + u + ']');
        l.textContent = promoUnitLabel(n, l.dataset.one, l.dataset.other);
      };
      const tick = () => {
        const r = promoRemaining(Date.now(), end);
        if (r.done) { box.hidden = true; clearInterval(timer); return false; }
        put('d', r.d, r.d);
        put('h', r.h, String(r.h).padStart(2, '0'));
        put('m', r.m, String(r.m).padStart(2, '0'));
        box.setAttribute('data-ready', '');
        return true;
      };
      if (tick()) timer = setInterval(tick, 30000);
    });
  }
  const api = { promoEndInstant, promoRemaining, promoUnitLabel, boot };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.OrganaPromo = api;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})(typeof window !== 'undefined' ? window : globalThis);
